/**
 * Bikitri Theme - Main JavaScript
 */

(function() {
  'use strict';

  /* --- Header scroll effect --- */
  const header = document.querySelector('.header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      header.classList.toggle('header--scrolled', currentScroll > 50);
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* --- Mobile menu toggle --- */
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileNav = document.querySelector('.header__nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('header__nav--open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  /* --- Cart drawer --- */
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');

  function bindCartEvents() {
    document.querySelectorAll('[data-cart-open]').forEach(btn =>
      btn.addEventListener('click', openCart)
    );
    document.querySelectorAll('[data-cart-close]').forEach(btn =>
      btn.addEventListener('click', closeCart)
    );
    const overlay = document.querySelector('.cart-drawer__overlay');
    if (overlay) overlay.addEventListener('click', closeCart);
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('cart-drawer--open');
    const overlay = document.querySelector('.cart-drawer__overlay');
    if (overlay) overlay.classList.add('cart-drawer__overlay--visible');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('cart-drawer--open');
    const overlay = document.querySelector('.cart-drawer__overlay');
    if (overlay) overlay.classList.remove('cart-drawer__overlay--visible');
    document.body.style.overflow = '';
  }

  async function refreshCartDrawer() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const drawer = document.querySelector('.cart-drawer');
      if (!drawer) return;

      // Update header cart count
      const titleEl = drawer.querySelector('.cart-drawer__title');
      if (titleEl) titleEl.textContent = 'Your Cart (' + cart.item_count + ')';

      // Update header icon count
      document.querySelectorAll('.header__cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      // Update free shipping bar
      const shippingBar = drawer.querySelector('.cart-drawer__shipping-bar');
      if (shippingBar) {
        const threshold = parseInt(drawer.dataset.freeShippingThreshold) || 5000;
        const remaining = Math.max(0, threshold - cart.total_price);
        const progress = Math.min(100, (cart.total_price / threshold) * 100);
        const fill = shippingBar.querySelector('.shipping-bar__fill');
        const text = shippingBar.querySelector('.shipping-bar__text');
        if (fill) fill.style.width = progress + '%';
        if (text) {
          if (cart.total_price >= threshold) {
            text.className = 'shipping-bar__text shipping-bar__text--success';
            text.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg> You\'ve earned free shipping!';
          } else if (cart.item_count > 0) {
            text.className = 'shipping-bar__text';
            text.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Add <strong>' + formatMoney(remaining) + '</strong> more for free shipping';
          }
        }
      }

      // Update free gift bar
      var giftBar = drawer.querySelector('.cart-drawer__gift-bar');
      if (giftBar) {
        var giftThreshold = parseInt(giftBar.dataset.giftThreshold) || 7500;
        var giftRemaining = Math.max(0, giftThreshold - cart.total_price);
        var giftProgress = Math.min(100, (cart.total_price / giftThreshold) * 100);
        var giftFill = giftBar.querySelector('.gift-bar__fill');
        var giftText = giftBar.querySelector('.gift-bar__text');
        if (giftFill) giftFill.style.width = giftProgress + '%';
        if (giftText) {
          if (cart.total_price >= giftThreshold) {
            giftText.className = 'gift-bar__text gift-bar__text--success';
            giftText.innerHTML = '<span class="gift-bar__icon">🎁</span> You unlocked your free gift!';
          } else if (cart.item_count > 0) {
            giftText.className = 'gift-bar__text';
            giftText.innerHTML = '<span class="gift-bar__icon">🎁</span> Add <strong>' + formatMoney(giftRemaining) + '</strong> more for a free gift!';
          }
        }
      }

      // Build items HTML
      const itemsEl = drawer.querySelector('.cart-drawer__items');
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--primary" style="margin-top:1.5rem">Continue Shopping</a></div>';
        const footer = drawer.querySelector('.cart-drawer__footer');
        if (footer) footer.remove();
        const upsell = drawer.querySelector('.cart-drawer__upsell');
        if (upsell) upsell.style.display = 'none';
      } else {
        let itemsHtml = '';
        cart.items.forEach(function(item) {
          const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';
          const imgSrc = item.image ? item.image : '';
          const imgTag = imgSrc
            ? '<img class="cart-item__image" src="' + imgSrc + '" alt="" width="80" height="80" loading="lazy">'
            : '';
          itemsHtml += '<div class="cart-item" data-cart-item data-line-key="' + item.key + '">'
            + '<a href="' + item.url + '">' + imgTag + '</a>'
            + '<div class="cart-item__details">'
            + '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>'
            + variantTitle
            + '<p class="cart-item__price-line">' + formatMoney(item.final_price)
            + (item.original_price > item.final_price
              ? ' <span class="cart-item__compare-price">' + formatMoney(item.original_price) + '</span>'
              + ' <span class="cart-item__save-badge">Save ' + formatMoney(item.original_price - item.final_price) + '</span>'
              : '')
            + '</p>'
            + '<div class="cart-item__actions">'
            + '<div class="cart-item__qty">'
            + '<button type="button" class="cart-item__qty-btn" data-cart-qty="decrease" data-key="' + item.key + '" aria-label="Decrease">-</button>'
            + '<span class="cart-item__qty-value">' + item.quantity + '</span>'
            + '<button type="button" class="cart-item__qty-btn" data-cart-qty="increase" data-key="' + item.key + '" aria-label="Increase">+</button>'
            + '</div>'
            + '<button type="button" class="cart-item__remove-btn" data-cart-qty="remove" data-key="' + item.key + '" aria-label="Remove">'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
            + '</button>'
            + '</div></div></div>';
        });
        itemsEl.innerHTML = itemsHtml;

        // Re-bind qty buttons
        bindCartQtyEvents();

        // Update subtotal in footer
        const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        // Show footer if missing
        if (!drawer.querySelector('.cart-drawer__footer')) {
          const footerHtml = '<div class="cart-drawer__footer">'
            + '<div class="cart-drawer__subtotal"><span>Subtotal</span><span data-cart-subtotal>' + formatMoney(cart.total_price) + '</span></div>'
            + '<p class="cart-drawer__tax-note">Shipping & taxes calculated at checkout</p>'
            + '<a href="/checkout" class="btn btn--primary btn--full btn--lg">Checkout</a>'
            + '</div>';
          drawer.insertAdjacentHTML('beforeend', footerHtml);
        }
      }
    } catch (err) {
      console.error('Failed to refresh cart drawer:', err);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* --- Cart drawer quantity buttons --- */
  function bindCartQtyEvents() {
    document.querySelectorAll('[data-cart-qty]').forEach(btn => {
      btn.replaceWith(btn.cloneNode(true));
    });
    document.querySelectorAll('[data-cart-qty]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const action = btn.dataset.cartQty;
        const qtyEl = btn.closest('.cart-item__actions')
          ? btn.closest('.cart-item__actions').querySelector('.cart-item__qty-value')
          : null;
        let newQty = qtyEl ? parseInt(qtyEl.textContent) : 1;

        if (action === 'decrease') newQty = Math.max(0, newQty - 1);
        else if (action === 'increase') newQty = newQty + 1;
        else if (action === 'remove') newQty = 0;

        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          });
          await refreshCartDrawer();
        } catch (err) {
          console.error('Cart update error:', err);
        }
      });
    });
  }

  /* --- Cart note toggle & save --- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-toggle-note]');
    if (toggle) {
      const body = toggle.closest('.cart-drawer__note').querySelector('[data-note-body]');
      if (body) {
        const isHidden = body.style.display === 'none';
        body.style.display = isHidden ? 'block' : 'none';
        toggle.classList.toggle('cart-drawer__note-toggle--open', isHidden);
      }
    }
  });

  let noteTimer = null;
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-cart-note]')) {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(async () => {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: e.target.value })
          });
        } catch (err) { console.error('Note save error:', err); }
      }, 500);
    }
  });

  /* --- Upsell quick add --- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });
      btn.textContent = 'Added!';
      await refreshCartDrawer();
      setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1200);
    } catch (err) {
      btn.textContent = 'Error';
      btn.disabled = false;
      setTimeout(() => { btn.textContent = originalText; }, 1500);
    }
  });

  bindCartEvents();
  bindCartQtyEvents();

  /* --- Accordion --- */
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion__item');
      const content = item.querySelector('.accordion__content');
      const isOpen = item.classList.contains('accordion__item--open');

      // Close all siblings
      item.parentElement.querySelectorAll('.accordion__item--open').forEach(openItem => {
        openItem.classList.remove('accordion__item--open');
        openItem.querySelector('.accordion__content').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('accordion__item--open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  /* --- Quantity selector --- */
  document.querySelectorAll('.quantity-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;

      if (btn.dataset.action === 'decrease') {
        val = Math.max(1, val - 1);
      } else if (btn.dataset.action === 'increase') {
        val = Math.min(99, val + 1);
      }
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* --- Product gallery thumbs --- */
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImage = thumb.closest('.product-gallery').querySelector('.product-gallery__main img');
      if (!mainImage) return;

      // Update main image using full-res data attribute
      mainImage.src = thumb.dataset.fullSrc;
      mainImage.dataset.zoomSrc = thumb.dataset.zoomSrc;
      mainImage.srcset = '';

      // Update active state
      thumb.parentElement.querySelectorAll('.product-gallery__thumb').forEach(t =>
        t.classList.remove('product-gallery__thumb--active')
      );
      thumb.classList.add('product-gallery__thumb--active');
    });
  });

  /* --- Gallery lightbox --- */
  const galleryMainImg = document.querySelector('.product-gallery__main img');
  const lightbox = document.getElementById('galleryLightbox');
  if (galleryMainImg && lightbox) {
    galleryMainImg.addEventListener('click', () => {
      lightbox.querySelector('.gallery-lightbox__img').src = galleryMainImg.dataset.zoomSrc || galleryMainImg.src;
      lightbox.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    });

    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target.classList.contains('gallery-lightbox__close')) {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') !== 'true') {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  /* --- Volume Discount --- */
  document.querySelectorAll('.volume-discount__tier').forEach(function(tier) {
    tier.addEventListener('click', function() {
      var wrapper = tier.closest('.volume-discount');
      wrapper.querySelectorAll('.volume-discount__tier').forEach(function(t) {
        t.classList.remove('volume-discount__tier--selected');
        t.querySelector('input').checked = false;
      });
      tier.classList.add('volume-discount__tier--selected');
      tier.querySelector('input').checked = true;
      var qty = parseInt(tier.dataset.qty) || 1;
      var qtyInput = document.querySelector('.quantity-input');
      if (qtyInput) qtyInput.value = qty;
    });
  });

  /* --- Bundle Variant Select + Add to Cart --- */
  document.querySelectorAll('[data-bundle-variant-select]').forEach(function(sel) {
    if (sel.tagName !== 'SELECT') return;
    sel.addEventListener('change', function() {
      var opt = sel.options[sel.selectedIndex];
      var card = sel.closest('[data-bundle-product]');
      if (!card) return;
      // Update image
      var img = card.querySelector('[data-bundle-img]');
      if (img && opt.dataset.img) img.src = opt.dataset.img;
      // Update price display
      var priceEl = card.querySelector('[data-bundle-price]');
      if (priceEl) {
        priceEl.dataset.bundlePrice = opt.dataset.price;
        priceEl.textContent = '$' + (parseInt(opt.dataset.price) / 100).toFixed(2);
      }
      // Recalculate bundle total
      updateBundlePricing(card.closest('.bundle-upsell'));
    });
  });

  function updateBundlePricing(wrapper) {
    if (!wrapper) return;
    var total = 0;
    wrapper.querySelectorAll('[data-bundle-price]').forEach(function(el) {
      total += parseInt(el.dataset.bundlePrice) || 0;
    });
    var pricingEl = wrapper.querySelector('[data-bundle-pricing]');
    if (!pricingEl) return;
    var discType = pricingEl.dataset.discountType;
    var discVal = parseInt(pricingEl.dataset.discountValue) || 0;
    var discAmount = discType === 'percent' ? Math.round(total * discVal / 100) : discVal * 100;
    var finalPrice = total - discAmount;

    var origEl = pricingEl.querySelector('[data-bundle-original]');
    var finalEl = pricingEl.querySelector('[data-bundle-final]');
    var saveEl = pricingEl.querySelector('[data-bundle-save]');
    if (origEl) origEl.textContent = '$' + (total / 100).toFixed(2);
    if (finalEl) finalEl.textContent = '$' + (finalPrice / 100).toFixed(2);
    if (saveEl) saveEl.textContent = 'Save $' + (discAmount / 100).toFixed(2) + '!';
  }

  document.querySelectorAll('[data-bundle-add]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrapper = btn.closest('.bundle-upsell');
      var selects = wrapper.querySelectorAll('[data-bundle-variant-select]');
      var addItems = [];
      selects.forEach(function(sel) {
        var vid = sel.tagName === 'SELECT' ? sel.value : sel.value;
        if (vid) addItems.push({ id: parseInt(vid), quantity: 1 });
      });
      if (addItems.length === 0) return;

      var origText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: addItems })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Added to Cart!';
        if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
        var drawer = document.querySelector('.cart-drawer');
        var overlay = document.querySelector('.cart-drawer__overlay');
        if (drawer) drawer.classList.add('cart-drawer--open');
        if (overlay) overlay.classList.add('cart-drawer__overlay--open');
        setTimeout(function() {
          btn.textContent = origText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        btn.textContent = origText;
        btn.disabled = false;
      });
    });
  });

  /* --- Video Tabs --- */
  document.querySelectorAll('.video-tabs').forEach(wrapper => {
    wrapper.querySelectorAll('.video-tabs__tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const idx = tab.dataset.tab;
        wrapper.querySelectorAll('.video-tabs__tab').forEach(t => t.classList.remove('video-tabs__tab--active'));
        wrapper.querySelectorAll('.video-tabs__panel').forEach(p => p.classList.remove('video-tabs__panel--active'));
        tab.classList.add('video-tabs__tab--active');
        const panel = wrapper.querySelector('[data-panel="' + idx + '"]');
        if (panel) panel.classList.add('video-tabs__panel--active');
        wrapper.querySelectorAll('video').forEach(v => { v.pause(); });
        wrapper.querySelectorAll('.video-tabs__play-btn').forEach(b => b.classList.remove('is-playing'));
      });
    });

    wrapper.querySelectorAll('.video-tabs__play-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.parentElement.querySelector('video');
        if (!video) return;
        if (video.paused) {
          video.play();
          btn.classList.add('is-playing');
        } else {
          video.pause();
          btn.classList.remove('is-playing');
        }
      });
    });
  });

  /* --- Variant selector --- */
  const variantDataEl = document.querySelector('[data-product-variants]');
  const productVariants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
  const variantSelect = document.querySelector('select[name="id"]');

  function getSelectedOptions() {
    const options = [];
    document.querySelectorAll('.product-info__variants').forEach(group => {
      const selected = group.querySelector('.variant-option--selected, .variant-swatch--selected');
      if (selected) {
        options.push(selected.dataset.optionValue);
      }
    });
    return options;
  }

  function findMatchingVariant(selectedOptions) {
    return productVariants.find(v =>
      v.options.every((opt, i) => selectedOptions[i] === undefined || opt === selectedOptions[i])
    );
  }

  function onVariantChange(clickedEl) {
    const group = clickedEl.closest('.product-info__variants');
    // Deselect siblings
    group.querySelectorAll('.variant-option--selected, .variant-swatch--selected').forEach(o => {
      o.classList.remove('variant-option--selected', 'variant-swatch--selected');
    });
    // Select clicked
    if (clickedEl.classList.contains('variant-swatch')) {
      clickedEl.classList.add('variant-swatch--selected');
    } else {
      clickedEl.classList.add('variant-option--selected');
    }

    // Update label
    const label = group.querySelector('.variant-label__selected');
    if (label) label.textContent = clickedEl.dataset.optionValue;

    // Find & set matching variant
    const selectedOptions = getSelectedOptions();
    const variant = findMatchingVariant(selectedOptions);
    if (variant && variantSelect) {
      variantSelect.value = variant.id;

      // Update price
      const priceEl = document.querySelector('.product-info__price');
      if (priceEl) {
        let priceHtml = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHtml += ' <span class="product-info__price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = priceHtml;
      }

      // Update main image if variant has featured_image
      if (variant.featured_image) {
        const mainImg = document.querySelector('.product-gallery__main img');
        if (mainImg) {
          const baseSrc = variant.featured_image.src;
          const sep = baseSrc.includes('?') ? '&' : '?';
          mainImg.src = baseSrc + sep + 'width=800';
          mainImg.srcset = '';
          mainImg.dataset.zoomSrc = baseSrc + sep + 'width=1600';
        }
      }

      // Update add-to-cart button
      const addBtn = document.querySelector('[data-add-to-cart] [type="submit"]');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    }
  }

  document.querySelectorAll('.variant-option, .variant-swatch').forEach(option => {
    option.addEventListener('click', () => onVariantChange(option));
  });

  /* --- Announcement bar dismiss --- */
  const announcementClose = document.querySelector('.announcement-bar__close');
  if (announcementClose) {
    announcementClose.addEventListener('click', () => {
      const bar = announcementClose.closest('.announcement-bar');
      bar.style.maxHeight = bar.offsetHeight + 'px';
      requestAnimationFrame(() => {
        bar.style.maxHeight = '0';
        bar.style.overflow = 'hidden';
        bar.style.padding = '0';
        bar.style.transition = 'all 0.3s ease';
      });
      sessionStorage.setItem('bikitri-announcement-dismissed', '1');
    });

    if (sessionStorage.getItem('bikitri-announcement-dismissed') === '1') {
      const bar = announcementClose.closest('.announcement-bar');
      if (bar) bar.style.display = 'none';
    }
  }

  /* --- Scroll animations (fade-in) --- */
  const fadeElements = document.querySelectorAll('.fade-in');
  if (fadeElements.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeElements.forEach(el => observer.observe(el));
  }

  /* --- Add to cart (AJAX) --- */
  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.textContent;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) throw new Error('Add to cart failed');

        const item = await response.json();
        btn.textContent = 'Added!';

        // Update cart count
        const countEls = document.querySelectorAll('.header__cart-count');
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        countEls.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        // Refresh cart drawer content then open
        await refreshCartDrawer();
        if (document.querySelector('.cart-drawer')) {
          openCart();
        }

        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      } catch (err) {
        console.error('Cart error:', err);
        btn.textContent = 'Error - Try Again';
        btn.disabled = false;
        setTimeout(() => { btn.textContent = originalText; }, 2000);
      }
    });
  });

})();
